function generateDescription(fixedDescription, h1, h1WithoutFilters, phone) {
  if (fixedDescription) return fixedDescription;
  if (h1WithoutFilters && h1 !== h1WithoutFilters)
    return `👶 ${h1} ✅, купить ${h1WithoutFilters} в Киеве и Украине, по выгодным ценам 💰. Покупайте ${h1} в интернет-магазине детской одежды ALFAKID`;
  if (h1)
    return `▶ Лучшая ⭐ цена на ${h1} 👶 в интернет-магазине детской одежды ALFAKID. Хотите купить ${h1} в Киеве с доставкой 🚗 по Украине? Заказывайте прямо сейчас по номеру ${phone} 📞`;
}

export default generateDescription;
